function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.56 4.553c-.666 0-1.012.448-1.012.777v28.733c0 .329.346.777 1.013.777h42.878c.667 0 1.013-.448 1.013-.777V5.33c0-.329-.346-.777-1.013-.777H2.561zM0 5.33C0 3.942 1.254 3 2.56 3h42.88C46.745 3 48 3.942 48 5.33v28.733c0 1.388-1.254 2.33-2.56 2.33H2.56c-1.306 0-2.56-.942-2.56-2.33V5.33z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.274 31.604c0-.43.347-.777.775-.777h2.177c.428 0 .774.348.774.777a.775.775 0 01-.774.776h-2.177a.775.775 0 01-.775-.776zM0 31.604c0-.43.347-.777.774-.777H41.42c.428 0 .775.348.775.777a.775.775 0 01-.775.776H.774A.775.775 0 010 31.604zM30.534 35.175a.773.773 0 011.079.19l4.815 6.884c.81 1.158-.016 2.751-1.426 2.751h-21.71c-1.414 0-2.238-1.602-1.42-2.759l4.87-6.88a.773.773 0 011.078-.184c.35.249.431.733.184 1.083l-4.869 6.88a.194.194 0 00.158.307h21.709a.194.194 0 00.158-.306l-4.815-6.884a.778.778 0 01.19-1.082zM1.936 38.075c0-.429.346-.776.774-.776h1.935a.775.775 0 010 1.553H2.71a.775.775 0 01-.774-.777zM6.451 38.075c0-.429.347-.776.774-.776h3.871a.775.775 0 010 1.553h-3.87a.775.775 0 01-.775-.777z",
  fill: "#2D2D2D"
});
function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/computer.svg";
export { SvgComputer as ReactComponent };